import React, { useCallback, useEffect, useState } from "react";
import { Search } from "modules/common/components/form/Search";
import styles from "./Filters.module.scss";
import { FiltersContract } from "./types";
import { DefaultSelectedOption, renderSingleOption, SimpleSelect } from "modules/common/services/form/select";
import { Classes } from "@blueprintjs/core";
import { observer } from "mobx-react";
import { DictionaryItemSnapshotType } from "modules/common/models/entity";
import { ALL_STATUSES } from "modules/common/constants";
import { Constants } from "modules/root/models/constants";
import {
  ProjectSelect,
  renderProjectOption,
  ProjectSelectedOption,
  filterProjectItemPredicate,
} from "modules/common/components/form/ProjectSelect";
import { OrderDictionaryItemType, OrderDictionaryType } from "modules/orders-manage/models/order-dictionary";

export const Filters: React.FC<FiltersProps> = (props) => {
  let options: { [k: string]: any } = {};
  const [filterItem, setfilterItem] = useState({ id: "", label: "" });
  const [orderItem, setorderItem] = useState<OrderDictionaryItemType | null>(null);

  const filterStatuses = [ALL_STATUSES, ...Constants.orderConfirmTypes];
  let i = 0;
  filterStatuses.forEach((label) => {
    let res: DictionaryItemSnapshotType = { id: i.toString(), label };
    options[i] = res;
    i++;
  });
  const item = options[0];
  useEffect(() => {
    setfilterItem(item);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { children, query, orders, setQuery, hideProject } = props;
  const { setOrderId, toggleFiltersStatus } = props;

  const selectStatuses = useCallback(
    (selection: string) => {
      let status = selection;
      if (selection === ALL_STATUSES) {
        status = "";
      }

      toggleFiltersStatus(status || "");
    },
    [toggleFiltersStatus]
  );

  const projectSelected = useCallback(
    (project: OrderDictionaryItemType | null) => {
      if (project !== null) {
        setOrderId(project.id);
        setorderItem(project);
      } else {
        setOrderId("");
        setorderItem(null);
      }
    },
    [setOrderId]
  );

  return (
    <div className={styles.filters}>
      <div className={"planr-mail-group"}></div>

      <div className={styles.statusFilter} style={{ width: "230px", marginLeft: "0px" }}>
        <StatusFilterHeader
          width={300}
          currentOptions={options}
          value={filterItem.id}
          onChange={async (status: any) => {
            setfilterItem(status);
            selectStatuses(status.label);
          }}
        />
      </div>
      {orders && !hideProject && (
        <div className={styles.orderFilter} style={!hideProject ? { width: "230px" } : {}}>
          <ProjectSelect
            className={`${Classes.FILL} planr-default-input`}
            filterable={true}
            itemPredicate={filterProjectItemPredicate}
            activeItem={orderItem}
            items={orders.orders}
            itemRenderer={renderProjectOption}
            onItemSelect={projectSelected}
            resetOnClose={true}
            inputProps={{
              placeholder: "Проект",
            }}
            popoverProps={{
              boundary: "viewport",
              popoverClassName: "import-spendings-table__select",
            }}
          >
            <ProjectSelectedOption option={orderItem} onClear={() => projectSelected(null)} noData="Объект" />
          </ProjectSelect>
        </div>
      )}
      {children}
      <div className={styles.tools}>
        <Search query={query} onSearch={setQuery} />
      </div>
    </div>
  );
};

interface FiltersProps extends FiltersContract {
  orders?: OrderDictionaryType;
  hideProject?: boolean;
}

interface StatusFilterHeaderProps {
  value: string;
  onChange: (value: any) => void;
  currentOptions: { [k: string]: any };
  width: number;
  filter?: string;
}

const StatusFilterHeader = observer(
  class extends React.Component<StatusFilterHeaderProps> {
    render() {
      const { width, value, currentOptions } = this.props;

      const option = currentOptions[value];

      return (
        <SimpleSelect
          className={`${Classes.FILL} planr-default-input`}
          filterable={false}
          items={Object.values(currentOptions)}
          itemRenderer={renderSingleOption}
          onItemSelect={this.onItemSelect}
          popoverProps={{
            boundary: "viewport",
            popoverClassName: "import-spendings-table__select",
          }}
        >
          <DefaultSelectedOption
            option={option}
            empty={!!Constants.employerDocumentType.values.length}
            style={{ overflow: "hidden", maxWidth: `${width - 3}px` }}
          />
        </SimpleSelect>
      );
    }

    onItemSelect = (item: SelectItem) => this.props.onChange(item);
  }
);
